<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">CHANGE PASSWORD</h4>
            </div>

        </div>
        <div class="container" style="padding:20px;">

            <form class="register-form" [formGroup]='createmeetingform' (ngSubmit)="postdata(createmeetingform)"
                autocomplete="off">
                <div class=" form-group row">
                    <div class="form-group col-md-6">
                        <label for="" class="form-label">Password<span style="color:red">*</span></label>
                        <div class="input-group"> <!-- Wrap input and eye icon in an input-group -->
                            <input id="password" type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" formControlName="password" placeholder="Password">
                            <div class="input-group-append">
                                <div class="input-group-text" (click)="togglePasswordVisibility()">
                                    <img src="assets/eye.png" alt="Eye Icon" style="height:9px;">
                                </div>
                            </div>
                        </div>
                        <div style="color:red;"
                        *ngIf=" createmeetingform.get('password').touched && createmeetingform.get('password').value==''">                                            Please fill
                        the field</div>
                    </div>
                    
                    <div class="form-group  col-md-6">
                        <label for="" class="form-label">Confirm Password<span style="color:red">*</span></label>
                        <div class="input-group">
                        <input type="{{ hidePassword1 ? 'password' : 'text' }}" class="form-control" formControlName="confirm_password"
                            id="confirm_password" placeholder="Enter Confirm Password" (blur)="handleBlurChange()" />
                            <div class="input-group-append">
                                <div class="input-group-text" (click)="togglePasswordVisibility1()">
                                    <img src="assets/eye.png" alt="Eye Icon" style="height:9px;">
                                </div></div></div>
                        <span *ngIf="password_wrong" style="color:red">Password is not match</span>
                    </div>
                </div>
                <br />
                <div class="container pr-4" style="width:200px;">
                    <button class="btn btn-primary btn btn-block"  [disabled]="password_wrong || isFormEmpty()">Change Password </button>
                </div>
            </form>
        </div>





